import { Checkbox, FormControlLabel } from '@mui/material'
import React from 'react'

//NEW: Компонент за списък с чекбокси за права
function PermissionCheckboxList({ perms, selectedPerms, onChange }) {
    const isSelected = (perm) => selectedPerms.some(sel => sel.value === perm.value)

    if (!perms || perms.length === 0) {
        return <div style={{ color: '#888', padding: '8px 0' }}>Няма налични права за избор.</div>
    }
    return (
        <>
            {perms.map(perm => {
                const isChild = /\s{2,}|^\s*[-•]/.test(perm.label) || [].includes(perm.label)
                return (
                    <FormControlLabel
                        key={perm.value}
                        control={
                            <Checkbox size='small' />
                        }
                        value={perm.value}
                        checked={isSelected(perm)}
                        onChange={e => {
                            let selected = Array.isArray(selectedPerms) ? [...selectedPerms] : []
                            if (e.target.checked) {
                                selected.push(perm)
                            } else {
                                selected = selected.filter(sel => sel.value !== perm.value)
                            }
                            onChange(selected)
                        }}
                        label={perm.label}
                        style={{
                            marginLeft: isChild ? "25px" : 0,
                            marginBottom: "-10px"
                        }}
                    />
                )
            })}
            {/* Hidden inputs for form submission, like MultiSelect */}
            {selectedPerms.map(s =>
                <input key={'m-' + s.value} type="hidden" name="perms[]" value={s.value} />
            )}
        </>
    )
}

export default PermissionCheckboxList
